'use client';

import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';

import { BlockClassyFragment } from '~/server/generated/contentful-graphql';

export function PreloadedClassyIframe({
  block,
  amount,
  isVisible = true,
  shouldPreload = false,
  utmCampaign,
  utmMedium,
}: {
  block: Pick<BlockClassyFragment, 'campaignId' | 'headline' | 'recurringNudges'>;
  amount?: number;
  isVisible?: boolean;
  shouldPreload?: boolean;
  utmCampaign?: string;
  utmMedium?: string;
}) {
  const [iframeRef, setIframeRef] = useState<HTMLIFrameElement | null>(null);
  const searchParams = useSearchParams();

  // Use provided props first, then fall back to URL search params, then defaults
  const cSrc = utmMedium || searchParams.get('utm_medium') || 'web';
  const cSrc2 = utmCampaign || searchParams.get('utm_campaign') || 'givehappiness';

  const src = `https://donate.starlight.org/give/${block.campaignId}#!/donation/checkout?eg=true${
    block.recurringNudges ? '&egrn=true' : ''
  }&c_src=${cSrc}&c_src2=${cSrc2}${amount ? `&amount=${amount}` : ''}`;

  // Preload the iframe when shouldPreload is true
  useEffect(() => {
    if (shouldPreload && iframeRef) {
      // Force the iframe to start loading
      iframeRef.src = src;
    }
  }, [shouldPreload, src, iframeRef]);

  return (
    <div
      className={`relative mx-auto w-full max-w-[480px] rounded-2xl px-0 md:px-4 md:pb-4 lg:bg-white [&_iframe]:h-[520px] xl:[&_iframe]:h-[600px] ${
        isVisible ? 'block' : 'hidden'
      }`}
    >
      <iframe
        ref={setIframeRef}
        // @ts-ignore
        allowpaymentrequest='true'
        className='w-full rounded-2xl'
        height='600'
        scrolling='no'
        src={shouldPreload ? src : isVisible ? src : ''}
        title={block.headline || 'Make a Donation'}
        loading={shouldPreload ? 'eager' : 'lazy'}
      />
    </div>
  );
}
